import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const portoVelhoShoppingTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#03a6a8',
    },
    secondary: {
      main: '#757575',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#007679',
    },
  },
};
